export const APP_CONSTANT = {
    USER_INFO: 'user_data',
    USER_ACCESS_TOKEN: 'access_token'
}